<template>
  <form>
    <b-field grouped class="columns">
      <b-field label="Description" class="column">
        <b-input v-model="freight.companyJobFreightDescription"
                 maxlength="220"
                 type="textarea"
                 placeholder="Freight description"
                 expanded></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="columns">
      <b-field label="Packaging" class="column">
        <b-input type="text" placeholder="Type of packaging" expanded v-model="freight.companyJobFreightPackagingType" />
      </b-field>

      <b-field label="Dimensions (inches)" class="column">
        <div class="columns">
          <b-input class="column" placeholder="L" expanded v-model.number="freight.companyJobFreightDimensionLength" />
        <b-input class="column" placeholder="H" expanded v-model.number="freight.companyJobFreightDimensionHeight" />
        <b-input class="column" placeholder="W" expanded v-model.number="freight.companyJobFreightDimensionWidth" />
          <span class="help" @click="toggleDimensionsHelp">
          <font-awesome-icon icon="question-circle"/>
        </span>
        </div>
      </b-field>
    </b-field>

    <b-field grouped class="columns">
      <b-field label="Quantity" class="column">
        <b-input placeholder="Total units" expanded v-model.number="freight.companyJobFreightQuantity" />
      </b-field>

      <b-field label="Pallets" class="column">
        <b-input placeholder="Number of pallets" expanded v-model.number="freight.companyJobFreightPallets" />
      </b-field>

      <b-field label="Weight" class="column">
        <b-field >
          <b-input placeholder="Total weight" expanded v-model.number="freight.companyJobFreightWeight" />
          <p class="control">
            <span class="button is-static">lbs</span>
          </p>
        </b-field>
      </b-field>

    </b-field>

    <b-field grouped class="columns">
      <b-field label="Category" class="column">
        <b-input type="text" placeholder="Freight category, e.g. Dry" expanded v-model="freight.companyJobFreightCategory" />
      </b-field>

      <!--
      <b-field label="NMFC" class="column">
        <b-select placeholder="NMFC Class" expanded v-model="freight.companyJobFreightNmfc">
          <option v-for="code in classCodes" :key="code">
            {{ code }}
          </option>
        </b-select>
      </b-field>
      -->

      <b-field label="HazMat" class="column">
        <b-input type="text" placeholder="HaZMat Code" expanded v-model="freight.companyJobFreightHazmatcode" />
      </b-field>
    </b-field>

    <b-modal :active.sync="isDimensionsHelpVisible">
      <figure class="image is-square">
        <img src="@/assets/dimensions.png" class="dimensions-help" title="dimensions" />
      </figure>
    </b-modal>

    <b-field label="Comments" >
      <b-input type="textarea" expanded v-model="freight.companyJobFreightComments"
               placeholder="Any comments for the Carrier such as dimensions for mixed shipments or references to purchase orders or other documents"  />
    </b-field>
    <!--
    <b-field label="Documents">
      <document-uploader :freight-key=""  v-model="freight.companyJobFreightDocuments"/>
    </b-field>
    -->
  </form>
</template>

<script>
import { isEmpty, isEqual, uniqueId } from 'lodash-es'

import nmfcClassCodes from '@/lookup-data/nmfc-class-codes'
import DocumentUploader from '@/components/DocumentUploader'

const defaultFreight = () => ({
  temporaryId: uniqueId('freight'),
  companyJobFreightDescription: '',
  companyJobFreightWeight: null,
  companyJobFreightQuantity: null,
  companyJobFreightPallets: null,
  companyJobFreightCategory: '',
  companyJobFreightNmfc: null,
  companyJobFreightHazmatcode: '',
  companyJobFreightPackagingType: '',
  companyJobFreightDimensionHeight: null,
  companyJobFreightDimensionLength: null,
  companyJobFreightDimensionWidth: null,
  companyJobFreightComments: '',
  companyJobFreightDocuments: []
})

export default {
  name: 'FreightForm',

  props: {
    value: {
      type: Object,
      default: defaultFreight
    }
  },

  data() {
    return {
      isDimensionsHelpVisible: false,
      freight: defaultFreight()
    }
  },

  computed: {
    classCodes() {
      return nmfcClassCodes.map((code) => `Class ${code}`)
    }
  },

  components: {
    DocumentUploader
  },

  methods: {
    toggleDimensionsHelp() {
      this.isDimensionsHelpVisible = !this.isDimensionsHelpVisible
    },
    notify() {
      this.$emit('input', this.freight)
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        const defaults = defaultFreight()
        this.freight = isEmpty(this.value) ? defaults : this.value
      }
    },

    freight: {
      deep: true,
      handler() {
        if (!isEqual(this.freight, this.value)) {
          this.notify()
        }
      }
    }
  }
}
</script>

<style scoped>
img.dimensions-help {
  max-width: 80vw;
  height: auto;
}
</style>
